// Shorten text.
export default function (text, length, suffix) {
  return text.replace(/(<([^>]+)>)/gi, '').substring(0, length) + suffix
}
